import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const pad = (n) => String(n).padStart(2, "0");

export const AlwaysOn = () => {
  const [time, setTime] = useState({ hour: 1, day: 1 });
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], [70, -70]);

  useEffect(() => {
    const t = setInterval(() => {
      setTime(({ hour, day }) => ({
        hour: hour >= 24 ? 1 : hour + 1,
        day: hour >= 24 ? (day >= 7 ? 1 : day + 1) : day,
      }));
    }, 450);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      ref={ref}
      data-testid="always-on-section"
      className="relative py-16 lg:py-24 px-5 sm:px-8 overflow-hidden bg-[#0c0c0e] border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto text-center">
        <Reveal>
          <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-6">Always On</p>
        </Reveal>
        <Reveal>
          <h2 className="font-display font-extrabold uppercase tracking-tighter text-neutral-50 text-4xl sm:text-5xl lg:text-7xl leading-[1.02]">
            Your business
            <br />
            never clocks off.
          </h2>
        </Reveal>
        <Reveal delay={0.05}>
          <motion.div
            style={{ x }}
            className="relative inline-block mt-4 select-none"
            aria-label="24 hours a day, 7 days a week"
          >
            <p
              className="font-display font-extrabold tracking-tighter leading-none text-outline text-[34vw] sm:text-[12rem] lg:text-[16rem]"
              aria-hidden="true"
            >
              24/7
            </p>
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <p
                data-testid="always-on-counter"
                aria-label={`Hour ${time.hour}, day ${time.day}`}
                className="font-display font-extrabold tracking-tighter leading-none text-neutral-50 text-[9vw] sm:text-6xl lg:text-7xl tabular-nums drop-shadow-[0_0_18px_rgba(12,12,14,0.95)]"
              >
                {pad(time.hour)}
                <span className="text-neutral-500 mx-2">/</span>
                {pad(time.day)}
              </p>
            </div>
          </motion.div>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-neutral-500 mt-6">
            Every hour. Every day.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
